(function () {
  if (window.twoNuSearchPopupReady) return;
  window.twoNuSearchPopupReady = true;

  var triggerSelector = '.two-nu-home-dock__search, .two-nu-page-dock__search, .two-nu-product-dock__search, [data-two-nu-search-trigger]';
  var popup;
  var panel;
  var form;
  var input;
  var resetButton;
  var statusEl;
  var resultsEl;
  var lastTrigger;
  var activeController;
  var popupMotionClosing = false;
  var mobileMedia = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  function text(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function label(name, fallback) {
    return (popup && popup.getAttribute('data-' + name)) || fallback || '';
  }

  function predictiveUrl() {
    var url = label('predictive-url', (window.routes && window.routes.predictive_search_url) || '/search/suggest');
    if (/^\/zh-[a-z]{2}\/search\/suggest/i.test(url)) return url.replace(/^\/zh-[a-z]{2}/i, '');
    return url;
  }

  function searchUrl() {
    return label('search-url', (window.routes && window.routes.search_url) || '/search');
  }

  function setStatus(message) {
    if (statusEl) statusEl.textContent = message || '';
  }

  function setResetState() {
    if (!resetButton || !input) return;
    resetButton.hidden = input.value.trim().length === 0;
  }

  function isPopupOpen() {
    return !!popup && !popup.hidden;
  }

  function syncMobilePosition(trigger) {
    if (!popup) return;
    popup.style.removeProperty('--two-nu-search-popup-mobile-bottom');
    if (!mobileMedia || !mobileMedia.matches || !trigger || typeof trigger.getBoundingClientRect !== 'function') return;
    var rect = trigger.getBoundingClientRect();
    if (!rect || rect.top <= 0) return;
    var bottomOffset = Math.max(56, Math.round(window.innerHeight - rect.top + 8));
    popup.style.setProperty('--two-nu-search-popup-mobile-bottom', bottomOffset + 'px');
  }

  function isSearchTrigger(target) {
    if (!target || !target.closest) return null;
    var trigger = target.closest(triggerSelector);
    if (!trigger || trigger.closest('[data-two-nu-search-popup]')) return null;
    if (trigger.matches('[data-two-nu-search-trigger]')) return trigger;
    var href = trigger.getAttribute('href') || '';
    if (!href) return null;
    var parsed;
    try {
      parsed = new URL(href, window.location.href);
    } catch (error) {
      return null;
    }
    var expected;
    try {
      expected = new URL(searchUrl(), window.location.href);
    } catch (error) {
      expected = new URL('/search', window.location.href);
    }
    return parsed.pathname.replace(/\/$/, '') === expected.pathname.replace(/\/$/, '') ? trigger : null;
  }

  function openPopup(trigger) {
    if (!popup) return;
    lastTrigger = trigger || document.activeElement;
    if (typeof window.twoNuCloseDockPopovers === 'function') {
      window.twoNuCloseDockPopovers({ immediate: true, focus: false });
    }
    if (typeof window.twoNuCloseDockCart === 'function') {
      window.twoNuCloseDockCart({ immediate: true, focus: false });
    }
    if (typeof window.twoNuCloseActivitySelector === 'function') {
      window.twoNuCloseActivitySelector('dock-switch', {
        persist: false,
        focus: false,
        immediate: true
      });
    }
    if (
      window.TwoNuCompare
      && typeof window.TwoNuCompare.dialogIsOpen === 'function'
      && window.TwoNuCompare.dialogIsOpen()
    ) {
      window.TwoNuCompare.close('dock-switch', {
        suppressFocusRestore: true,
        immediate: true
      });
    }
    if (
      panel
      && window.twoNuDockPopupMotion
      && typeof window.twoNuDockPopupMotion.cancel === 'function'
    ) {
      window.twoNuDockPopupMotion.cancel(panel);
    }
    popupMotionClosing = false;
    popup.removeAttribute('data-two-nu-motion-closing');
    syncMobilePosition(lastTrigger);
    popup.hidden = false;
    popup.classList.add('is-open');
    document.body.classList.add('two-nu-search-popup-open');
    if (panel) panel.setAttribute('aria-modal', 'false');
    window.requestAnimationFrame(function () {
      if (
        panel
        && window.twoNuDockPopupMotion
        && typeof window.twoNuDockPopupMotion.open === 'function'
      ) {
        window.twoNuDockPopupMotion.open(panel, lastTrigger);
      }
      if (panel) panel.focus({ preventScroll: true });
    });
  }

  function closePopup(options) {
    if (!popup || popup.hidden) return Promise.resolve();
    var settings = Object.assign({ immediate: false, focus: true }, options || {});
    var closingTrigger = lastTrigger;
    var finalize = function () {
      popupMotionClosing = false;
      popup.classList.remove('is-open');
      popup.removeAttribute('data-two-nu-motion-closing');
      document.body.classList.remove('two-nu-search-popup-open');
      popup.hidden = true;
      if (
        settings.focus
        && closingTrigger
        && typeof closingTrigger.focus === 'function'
        && closingTrigger.isConnected
      ) {
        window.requestAnimationFrame(function () {
          closingTrigger.focus({ preventScroll: true });
        });
      }
    };
    if (
      settings.immediate
      || !panel
      || !window.twoNuDockPopupMotion
      || typeof window.twoNuDockPopupMotion.close !== 'function'
    ) {
      if (
        panel
        && window.twoNuDockPopupMotion
        && typeof window.twoNuDockPopupMotion.cancel === 'function'
      ) {
        window.twoNuDockPopupMotion.cancel(panel);
      }
      finalize();
      return Promise.resolve();
    }
    if (popupMotionClosing) return Promise.resolve();
    popupMotionClosing = true;
    popup.setAttribute('data-two-nu-motion-closing', 'true');
    return window.twoNuDockPopupMotion.close(panel, closingTrigger).then(finalize);
  }

  window.twoNuCloseSearchPopup = closePopup;

  function clearResults() {
    if (resultsEl) {
      resultsEl.textContent = '';
      resultsEl.hidden = true;
    }
  }

  function createThumb(result) {
    var thumb = document.createElement('span');
    thumb.className = 'two-nu-search-popup__thumb';
    if (result.image) {
      var img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = '';
      img.src = result.image;
      thumb.appendChild(img);
    } else {
      thumb.textContent = '2nu';
    }
    return thumb;
  }

  function createResult(result) {
    var item;
    if (result.searchTerm) {
      item = document.createElement('button');
      item.type = 'button';
      item.className = 'two-nu-search-popup__suggestion';
      item.addEventListener('click', function () {
        if (input) input.value = result.searchTerm;
        setResetState();
        runSearch(result.searchTerm);
      });
    } else {
      item = document.createElement('a');
      item.className = 'two-nu-search-popup__result';
      item.href = result.url;
      item.appendChild(createThumb(result));
    }

    var body = document.createElement('span');
    body.className = 'two-nu-search-popup__result-body';

    var type = document.createElement('span');
    type.className = 'two-nu-search-popup__type';
    type.textContent = result.typeLabel;

    var title = document.createElement('strong');
    title.className = 'two-nu-search-popup__title';
    title.textContent = result.title;

    body.appendChild(type);
    body.appendChild(title);

    if (result.meta) {
      var meta = document.createElement('span');
      meta.className = 'two-nu-search-popup__meta';
      meta.textContent = result.meta;
      body.appendChild(meta);
    }

    item.appendChild(body);
    return item;
  }

  function titleFromLink(link) {
    var heading = link.querySelector('.predictive-search__item-heading');
    return text(heading ? heading.textContent : link.textContent);
  }

  function imageFromLink(link) {
    var img = link.querySelector('img');
    return img ? img.currentSrc || img.src || '' : '';
  }

  function metaFromLink(link) {
    var price = link.querySelector('.price, .price-item, .predictive-search__item-vendor');
    return text(price ? price.textContent : '');
  }

  function normalizeUrl(href) {
    try {
      return new URL(href, window.location.href).toString();
    } catch (error) {
      return href || '#';
    }
  }

  function shouldSkipSearchLink(url) {
    try {
      var parsed = new URL(url, window.location.href);
      var expected = new URL(searchUrl(), window.location.href);
      return parsed.pathname.replace(/\/$/, '') === expected.pathname.replace(/\/$/, '');
    } catch (error) {
      return false;
    }
  }

  function collectLinks(root, selector, typeLabel, options) {
    var output = [];
    var opts = options || {};
    Array.prototype.forEach.call(root.querySelectorAll(selector), function (link) {
      var title = titleFromLink(link);
      var href = link.getAttribute('href') || '';
      if (!title || !href) return;
      var url = normalizeUrl(href);
      if (opts.asSearchTerm || shouldSkipSearchLink(url)) {
        output.push({
          title: title,
          typeLabel: typeLabel,
          searchTerm: title
        });
        return;
      }
      output.push({
        title: title,
        typeLabel: typeLabel,
        url: url,
        image: imageFromLink(link),
        meta: metaFromLink(link)
      });
    });
    return output;
  }

  function parseResults(html, term) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var root = doc.querySelector('#shopify-section-predictive-search') || doc;
    var products = collectLinks(root, '#predictive-search-results-products-list a', label('products-label', 'Products'));
    var pages = collectLinks(root, '#predictive-search-results-pages-list-desktop a, #predictive-search-results-pages-list-mobile a', label('pages-label', 'Pages'));
    var suggestions = collectLinks(root, '#predictive-search-results-queries-list a[href*="/search"]', label('suggestions-label', 'Suggestions'), { asSearchTerm: true });
    var collections = collectLinks(root, '#predictive-search-results-queries-list a[href*="/collections/"]', label('suggestions-label', 'Suggestions'));
    var seen = {};
    var ordered = products.concat(pages, collections, suggestions).filter(function (result) {
      var key = (result.searchTerm ? 'term:' + result.searchTerm : 'url:' + result.url) + '|' + result.title;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    }).slice(0, 8);
    return {
      results: ordered,
      status: ordered.length ? '' : label('empty-label', 'No results found').replace('__TERM__', term)
    };
  }

  function renderResults(payload, term) {
    clearResults();
    if (!resultsEl) return;
    if (!payload.results.length) {
      setStatus(label('empty-label', 'No results found').replace('__TERM__', term));
      return;
    }
    var fragment = document.createDocumentFragment();
    payload.results.forEach(function (result) {
      fragment.appendChild(createResult(result));
    });
    resultsEl.appendChild(fragment);
    resultsEl.hidden = false;
    setStatus(payload.status || '');
  }

  function searchEndpoint(term) {
    var url = new URL(predictiveUrl(), window.location.href);
    url.searchParams.set('q', term);
    url.searchParams.set('section_id', 'predictive-search');
    return url.toString();
  }

  function runSearch(rawTerm) {
    var term = text(rawTerm);
    if (!term) {
      if (input) input.focus();
      return;
    }
    if (activeController) activeController.abort();
    activeController = new AbortController();
    clearResults();
    setStatus(label('loading-label', 'Loading...'));
    fetch(searchEndpoint(term), { signal: activeController.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        renderResults(parseResults(html, term), term);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        clearResults();
        setStatus(label('empty-label', 'No results found').replace('__TERM__', term));
      });
  }

  function init() {
    popup = document.querySelector('[data-two-nu-search-popup]');
    if (!popup) return;
    panel = popup.querySelector('.two-nu-search-popup__panel');
    form = popup.querySelector('[data-two-nu-search-form]');
    input = popup.querySelector('[data-two-nu-search-input]');
    resetButton = popup.querySelector('[data-two-nu-search-reset]');
    statusEl = popup.querySelector('[data-two-nu-search-status]');
    resultsEl = popup.querySelector('[data-two-nu-search-results]');

    document.addEventListener('click', function (event) {
      var trigger = isSearchTrigger(event.target);
      if (!trigger) return;
      event.preventDefault();
      if (isPopupOpen()) {
        closePopup();
        return;
      }
      openPopup(trigger);
    }, true);

    popup.addEventListener('click', function (event) {
      if (event.target === popup || event.target.matches('[data-two-nu-search-backdrop]')) {
        closePopup({ focus: false });
      }
    });
    popup.querySelector('[data-two-nu-search-close]')?.addEventListener('click', function (event) {
      event.preventDefault();
      closePopup({ focus: true });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });

    window.addEventListener('resize', function () {
      if (isPopupOpen()) syncMobilePosition(lastTrigger);
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        runSearch(input ? input.value : '');
      });
      form.addEventListener('reset', function () {
        window.setTimeout(function () {
          setResetState();
          clearResults();
          setStatus('');
          if (input) input.focus();
        }, 0);
      });
    }

    if (input) {
      input.addEventListener('input', setResetState);
    }

    Array.prototype.forEach.call(popup.querySelectorAll('[data-two-nu-search-chip]'), function (chip) {
      chip.addEventListener('click', function () {
        var term = chip.getAttribute('data-two-nu-search-chip') || text(chip.textContent);
        if (input) input.value = term;
        setResetState();
        runSearch(term);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
